import type { ReactNode } from 'react';
import type { DefaultTheme } from 'styled-components';
import type { AlertProps } from '../Alert';
import { Icon } from '../../icon';

export const getAlertIconByType = (type: AlertProps['type'], theme: DefaultTheme): ReactNode => {
  switch (type) {
    case 'success':
      return (
        <Icon
          $fontSize={theme.typography.fontSize[4]}
          color={theme.color.core.green.main[700]}
          iconString="circleCheckSolid"
        />
      );
    case 'info':
      return (
        <Icon
          $fontSize={theme.typography.fontSize[4]}
          color={theme.color.semantic.feedback.type.info}
          iconString="infoSolid"
        />
      );
    case 'warning':
      return (
        <Icon
          $fontSize={theme.typography.fontSize[4]}
          color={theme.color.core.orange.main[900]}
          iconString="diamondExclamationSolid"
        />
      );
    case 'error':
      return (
        <Icon
          $fontSize={theme.typography.fontSize[4]}
          color={theme.color.core.red.main[700]}
          iconString="triangleExclamationSolid"
        />
      );
    default:
      return (
        <Icon
          $fontSize={theme.typography.fontSize[4]}
          color={theme.color.semantic.feedback.type.info}
          iconString="infoSolid"
        />
      );
  }
};
